import { useContext, useMemo } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { snjContact } from "../ones/Footer";

const menuLinks = [
  { label: "Home", item: "home" },
  { label: "Services", item: "services" },
  { label: "Projects", item: "projects" },
  { label: "Contacts", item: "contact_us" },
];

const aboutLinks = [
  { label: "Overview", item: "about_us", subItem: "overview" },
  { label: "Team", item: "about_us", subItem: "team" },
  { label: "Legal", item: "about_us", subItem: "policies" },
];

const phoneNumber = snjContact.phone;

export default function TopBar() {
  const appContext = useContext(AppContext);

  const activeItem = useMemo(() => {
    if (!appContext.navItem || appContext.navItem === "home") {
      return "home";
    }

    if (appContext.navItem === "about_us") {
      return "about_us";
    }

    if (appContext.navItem === "contact_us") {
      return "contact_us";
    }

    if (appContext.navItem === "projects") {
      return "projects";
    }

    if (appContext.navItem === "services") {
      return "services";
    }

    return "";
  }, [appContext.navItem]);

  function goTo(nav) {
    appContext.navTo(typeof nav === "string" ? { item: nav } : nav);
  }

  return (
    <header
      className="TopBar"
      data-scrolled={appContext.isScrolled}
    >
      <div className="body">
        <div className="tgm-orion-topbar-shell">
          <div className="container">
            <div className="tgm-orion-topbar-row">
              <button
                type="button"
                className="tgm-orion-brand"
                onClick={() => goTo("home")}
                aria-label="Go to home"
              >
                <span className="tgm-orion-brand-mark">
                  <img src={logo} alt="SNJ Tanzania Limited logo" />
                </span>
              </button>

              <nav className="tgm-orion-nav" aria-label="Primary">
                {menuLinks.slice(0, 1).map((link) => (
                  <button
                    key={link.item}
                    type="button"
                    className="tgm-orion-nav-link font-semi-bold"
                    data-active={activeItem === link.item}
                    onClick={() => goTo(link.item)}
                  >
                    <span>{link.label}</span>
                  </button>
                ))}

                <div className="tgm-orion-nav-dropdown">
                  <button
                    type="button"
                    className="tgm-orion-nav-link font-semi-bold"
                    data-active={activeItem === "about_us"}
                    onClick={() =>
                      goTo({ item: "about_us", subItem: "overview" })
                    }
                  >
                    <span>About</span>
                  </button>
                  <div className="tgm-orion-dropdown-menu">
                    {aboutLinks.map((link) => (
                      <button
                        key={link.subItem}
                        type="button"
                        onClick={() => goTo(link)}
                      >
                        {link.label}
                      </button>
                    ))}
                  </div>
                </div>

                {menuLinks.slice(1).map((link) => {
                  return (
                    <button
                      key={link.item}
                      type="button"
                      className="tgm-orion-nav-link font-semi-bold"
                      data-active={activeItem === link.item}
                      onClick={() => goTo(link.item)}
                    >
                      <span>{link.label}</span>
                    </button>
                  );
                })}
              </nav>

              <a
                className="tgm-orion-topbar-cta font-semi-bold"
                href={`tel:${phoneNumber.replace(/\s/g, "")}`}
                aria-label={`Call ${phoneNumber}`}
              >
                {phoneNumber}
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
